import { EARTH_RADIUS } from 'constants/units';
import toRad from './toRad';

const computeDistanceBetween = (from, to, radius = EARTH_RADIUS) => {
  const dLat = toRad(to.latitude - from.latitude);
  const dLong = toRad(to.longitude - from.longitude);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(from.latitude)) *
      Math.cos(toRad(to.latitude)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = radius * c;

  return distance;
};

export default computeDistanceBetween;
